<template>
  <v-card variant="flat">
    <v-card-title class="typography-body-sm-bold text--color-text-secondary">
      {{ eventType }}
    </v-card-title>
    <v-card-text>
      <p v-if="formattedDateTime" class="typography-caption text-tertiary">
        @ {{ formattedDateTime }}
      </p>
    </v-card-text>
  </v-card>
</template>
<script>
import { defineComponent } from 'vue';
import { isString, trim } from 'lodash';
import useAssetVisitEvent from './useAssetVisitEvent';

export default defineComponent({
  name: 'AssetVisitCanceledEvent',
  components: {},
  props: {
    event: {
      type: Object,
      required: true,
      validator(value) {
        return (
          typeof value === 'object' &&
          value !== null &&
          isString(value.eventType) &&
          trim(value.eventType) !== '' &&
          isString(value.createDateTime) &&
          trim(value.createDateTime) !== ''
        );
      }
    },
    timezone: {
      type: String,
      required: false,
      default: null
    }
  },
  setup(props) {
    const { formattedDateTime, eventType } = useAssetVisitEvent(props.event, props.timezone);

    return {
      formattedDateTime,
      eventType
    };
  }
});
</script>
